import Vue from "vue";
import Router from "vue-router";
import Homepage from "@/views/home/homepage.vue";

//後台
import Admin from "@/views/admin.vue";
import AdminOrderList from "@/views/admin/admin_orderList.vue";
import AdminOrderDetail from "@/views/admin/admin_orderDetail.vue";
import AdminLatestNewsList from "@/views/admin/admin_latest_newsList.vue";
import AdminCreateNews from "@/views/admin/admin_create_news.vue";
import AdminEditNews from "@/views/admin/admin_edit_news.vue";
import AdminEditGoldFee from "@/views/admin/admin_edit_goldFee.vue";
import AdminLogin from "@/views/admin/admin_login.vue";
import AdminSpecialMemberList from "@/views/admin/admin_specialMemberList.vue";

//前台進入點
import Gold from "@/views/gold.vue";

//會員
import Member from "@/views/member/member.vue";
import MemberForm from "@/views/member/member_form.vue";
import MemberLogin from "@/views/member/member_login.vue";
import MemberOrder from "@/views/member/member_order.vue";
import MemberOrderdetail from "@/views/member/member_orderdetail.vue";
import MemberMobile from "@/views/member/member_mobile.vue";
import MemberMobileNav from "@/components/member/member_mobile_nav.vue";
import ContractedStoreForm from "@/views/member/contracted_store_form.vue";

//購物車
import Cart from "@/views/cart/cart.vue";
import CartOrder from "@/views/cart/cart_order.vue";
import CartInfo from "@/views/cart/cart_info.vue";
import CartConfirm from "@/views/cart/cart_confirm.vue";
import CartFinish from "@/views/cart/cart_finish.vue";
import CartRenew from "@/views/cart/cart_renew.vue";

//客製化金牌
import Customize from "@/views/customize/customize.vue";
import CustomizeStar from "@/views/customize/customize_star.vue";
import CustomizeStep1 from "@/views/customize/customize_step1.vue";
import CustomizeStep2 from "@/views/customize/customize_step2.vue";
import CustomizeStep3 from "@/views/customize/customize_step3.vue";
import CustomizeStep4 from "@/views/customize/customize_step4.vue";
import customizeFan from "@/views/customize/customize_fan";
import customizeGift from "@/views/customize/customize_gift";

//說明與服務
import Service from "@/views/service/service.vue";
import ServiceShop from "@/views/service/service_shop.vue";
import ServiceFactory from "@/views/service/service_factory.vue";
import ServicePayment from "@/views/service/service_payment.vue";
import ServiceShipping from "@/views/service/service_shipping.vue";
import ServiceGoldprice from "@/views/service/service_goldprice.vue";
import ServiceTakeback from "@/views/service/service_takeback.vue";
import ServiceMobile from "@/views/service/service_mobile.vue";
import ServiceMobileNav from "@/components/service/service_mobile_nav.vue";
import ServiceGuotedPrice from "@/views/service/service_quoted_price.vue";

//最新消息
import LatestNewsList from "@/views/news/latest_newsList.vue";

//隱私權政策
import PrivacyPolicy from "@/views/privacy/privacy_policy.vue";

//服務條款
import TermsOfService from "@/views/termsOfService/terms_of_service.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      redirect: "/gold"
    },
    {
      path: "/gold",
      name: "gold",
      component: Gold,
      redirect: "/gold/homepage",
      children: [
        {
          path: "/gold/homepage",
          name: "homepage",
          component: Homepage
        },
        {
          path: "/gold/member",
          name: "member",
          redirect: "/gold/member/member_form",
          component: Member,
          children: [
            {
              path: "/gold/member/member_form",
              name: "memberForm",
              component: MemberForm
            },
            {
              path: "/gold/member/member_order",
              name: "member_order",
              component: MemberOrder
            },
            {
              path: "/gold/member/member_orderdetail",
              name: "member_orderdetail",
              component: MemberOrderdetail
            },
            {
              path: "/gold/member/contracted_store_form",
              name: "contracted_store_form",
              component: ContractedStoreForm
            }
          ]
        },
        {
          path: "/gold/member_login",
          name: "member_login",
          component: MemberLogin
        },
        {
          path: "/gold/cart",
          name: "cart",
          redirect: "/gold/cart/cart_order",
          component: Cart,
          children: [
            {
              path: "/gold/cart/cart_order",
              name: "cart_order",
              component: CartOrder
            },
            {
              path: "/gold/cart/cart_info",
              name: "cart_info",
              component: CartInfo
            },
            {
              path: "/gold/cart/cart_confirm",
              name: "cart_confirm",
              component: CartConfirm
            },
            {
              path: "/gold/cart/cart_finish/:id",
              name: "cart_finish",
              component: CartFinish,
              props: true
            },
            {
              path: "/gold/cart/cart_renew/:oldId/:newId",
              name: "cart_renew",
              component: CartRenew,
              props: true
            }
          ]
        },
        {
          path: "/gold/customize",
          name: "customize",
          redirect: "/gold/customize/customize_star",
          component: Customize,
          children: [
            {
              path: "/gold/customize/customize_star",
              name: "customize_star",
              component: CustomizeStar
            },
            {
              path: "/gold/customize/customize_step1",
              name: "customize_step1",
              component: CustomizeStep1
            },
            {
              path: "/gold/customize/customize_step2",
              name: "customize_step2",
              component: CustomizeStep2
            },
            {
              path: "/gold/customize/customize_step3",
              name: "customize_step3",
              component: CustomizeStep3
            },
            {
              path: "/gold/customize/customize_step4",
              name: "customize_step4",
              component: CustomizeStep4
            },
            {
              path: "/gold/customize/customize_fan",
              name: "customize_fan",
              component: customizeFan
            },
            {
              path: "/gold/customize/customize_gift",
              name: "customize_gift",
              component: customizeGift
            }
          ]
        },
        {
          path: "/gold/service",
          name: "service",
          redirect: "/gold/service/service_shop",
          component: Service,
          children: [
            {
              path: "/gold/service/service_shop",
              name: "service_shop",
              component: ServiceShop
            },
            {
              path: "/gold/service/service_factory",
              name: "service_factory",
              component: ServiceFactory
            },
            {
              path: "/gold/service/service_payment",
              name: "service_payment",
              component: ServicePayment
            },
            {
              path: "/gold/service/service_shipping",
              name: "service_shipping",
              component: ServiceShipping
            },
            {
              path: "/gold/service/service_goldprice",
              name: "service_goldprice",
              component: ServiceGoldprice
            },
            {
              path: "/gold/service/service_takeback",
              name: "service_takeback",
              component: ServiceTakeback
            },
            {
              path: "/gold/service/service_quoted_price",
              name: "service_quoted_price",
              component: ServiceGuotedPrice
            }
          ]
        },
        {
          path: "/gold/member_mobile",
          name: "member_mobile",
          redirect: "/gold/member_mobile/member_mobile_nav",
          component: MemberMobile,
          children: [
            {
              path: "/gold/member_mobile/member_mobile_nav",
              name: "member_mobile_nav",
              component: MemberMobileNav
            },
            {
              path: "/gold/member_mobile/member_form",
              name: "member_mobile_form",
              component: MemberForm
            },
            {
              path: "/gold/member_mobile/member_order",
              name: "member_mobile_order",
              component: MemberOrder
            },
            {
              path: "/gold/member_mobile/member_orderdetail",
              name: "member_mobile_orderdetail",
              component: MemberOrderdetail
            },
            {
              path: "/gold/member_mobile/contracted_store_form",
              name: "member_mobile_contracted_store_form",
              component: ContractedStoreForm
            }
          ]
        },
        {
          path: "/gold/service_mobile",
          name: "service_mobile",
          redirect: "/gold/service_mobile/service_mobile_nav",
          component: ServiceMobile,
          children: [
            {
              path: "/gold/service_mobile/service_mobile_nav",
              name: "service_mobile_nav",
              component: ServiceMobileNav
            },
            {
              path: "/gold/service_mobile/service_shop",
              name: "service_mobile_shop",
              component: ServiceShop
            },
            {
              path: "/gold/service_mobile/service_factory",
              name: "service_mobile_factory",
              component: ServiceFactory
            },
            {
              path: "/gold/service_mobile/service_payment",
              name: "service_mobile_payment",
              component: ServicePayment
            },
            {
              path: "/gold/service_mobile/service_shipping",
              name: "service_mobile_shipping",
              component: ServiceShipping
            },
            {
              path: "/gold/service_mobile/service_goldprice",
              name: "service_mobile_goldprice",
              component: ServiceGoldprice
            },
            {
              path: "/gold/service_mobile/service_takeback",
              name: "service_mobile_takeback",
              component: ServiceTakeback
            },
            {
              path: "/gold/service_mobile/service_quoted_price",
              name: "service_mobile_service_quoted_price",
              component: ServiceGuotedPrice
            }
          ]
        },
        {
          path: "/gold/latest_newsList",
          name: "latest_newsList",
          component: LatestNewsList
        },
        {
          path: "/gold/privacy_policy",
          name: "privacy_policy",
          component: PrivacyPolicy
        },
        {
          path: "/gold/terms_of_service",
          name: "terms_of_service",
          component: TermsOfService
        }
      ]
    },
    {
      path: "/admin",
      name: "admin",
      redirect: "/admin/login",
      component: Admin,
      children: [
        {
          path: "/admin/login",
          name: "admin_login",
          component: AdminLogin
        },
        {
          path: "/admin/orderList",
          name: "admin_orderList",
          component: AdminOrderList
        },
        {
          path: "/admin/orderDetail/:id",
          name: "admin_orderDetail",
          component: AdminOrderDetail,
          props: true
        },
        {
          path: "/admin/latest_newsList",
          name: "admin_latest_newsList",
          component: AdminLatestNewsList
        },
        {
          path: "/admin/create_news",
          name: "admin_create_news",
          component: AdminCreateNews
        },
        {
          path: "/admin/edit_news/:id",
          name: "admin_edit_news",
          component: AdminEditNews,
          props: true
        },
        {
          path: "/admin/edit_goldFee",
          name: "admin_edit_goldFee",
          component: AdminEditGoldFee
        },
        {
          path: "/admin/special_memberList",
          name: "admin_special_memberList",
          component: AdminSpecialMemberList
        }
      ]
    },
    {
      path: "*",
      redirect: "/gold"
    }
  ]
});
router.beforeEach((to, from, next) => {
  if (to.name !== "admin_login" && to.fullPath.indexOf("admin") !== -1) {
    if (router.app.$options.store.getters.getBackstageToken === "") {
      next({ name: "admin_login" });
    }
    next();
  } else {
    next();
  }
  next();
});

export default router;
